import axiosInstance from './api';

const contactUsService = {
    contactUs(data) {
        return axiosInstance.post('/contact-us', { ...data }).catch(console.error);
    },
};

export default contactUsService;
